export const THEMES = {
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  NATURE: 'NATURE',
  PETER: 'PETER',
  PARTYINVITATIONS: 'PARTYINVITATIONS',
  PARTY411: 'PARTY411',
};
